const endPoints = {
  projectList: `/api/projects`,
  siteSettings: `/api/site-settings`,
  userInfo: "/api/user-info",
};

export { endPoints };
